import { useCallback, useState } from 'react';
import { MenuItemResponse, MenuType } from 'api/models';
import {
  CartContextType,
  initialOrderContext,
  Meals,
} from 'components/Cart/cartContext';
import { isMenuItemDivisible } from 'utils/menuItem';

export const useOrder = (): CartContextType => {
  const [meals, setMeals] = useState(initialOrderContext.meals);

  const addMeal = useCallback(
    (meal: MenuItemResponse, day: string, menuType: MenuType) => {
      setMeals((prevState) => {
        const stateMeal = prevState[meal.id];
        const currentMealAmount = stateMeal?.quantity || 0;

        let newQuantity;
        if (isMenuItemDivisible(meal)) {
          newQuantity = currentMealAmount + (currentMealAmount ? 0.5 : 1);
        } else {
          newQuantity = currentMealAmount + 1;
        }

        return {
          ...prevState,
          [meal.id]: {
            item: { ...meal },
            quantity: newQuantity,
            day,
            menuType,
          },
        };
      });
    },
    [],
  );

  const removeMeal = useCallback(
    (meal: MenuItemResponse, day: string, menuType: MenuType) => {
      setMeals((prevState) => {
        if (!prevState[meal.id]) {
          return prevState;
        }
        const stateMeal = prevState[meal.id];
        const currentMealAmount = stateMeal.quantity;

        if (!currentMealAmount) {
          return prevState;
        }

        const newAmount =
          currentMealAmount - (isMenuItemDivisible(meal) ? 0.5 : 1);

        if (newAmount === 0) {
          let newState = { ...prevState };
          delete newState[meal.id];
          return newState;
        }

        return {
          ...prevState,
          [meal.id]: {
            item: { ...meal },
            quantity: newAmount,
            day,
            menuType,
          },
        };
      });
    },
    [],
  );

  const updateOrder = useCallback((meals: Meals) => {
    setMeals(meals);
  }, []);

  const clearOrder = useCallback(() => {
    setMeals(initialOrderContext.meals);
  }, []);

  return {
    addMeal,
    updateOrder,
    clearOrder,
    meals,
    setMeals,
    removeMeal,
  };
};
